import styled from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

export const FilterContentContainer = styled(Stack)`
    row-gap: 16px;
    padding-right: 32px;
`;
